import { CreateEventRegistration } from '../generated/api/dsv-public/model';
import { RegistrantInfo } from '../forms/form.types';

export const mapEntriesToRegistrant: (registrationEntries: CreateEventRegistration) => RegistrantInfo = (
  registrationEntries: CreateEventRegistration
): RegistrantInfo => {
  return {
    firstName: registrationEntries.fields['firstName'] as any,
    lastName: registrationEntries.fields['lastName'] as any,
    email: registrationEntries.fields['email'] as any,
    mobile: registrationEntries.fields['mobile'] as any,
    address: registrationEntries.fields['address'] as any,
    zipCode: registrationEntries.fields['zipCode'] as any,
    city: registrationEntries.fields['city'] as any,
    country: registrationEntries.fields['country'] as any,
  } as RegistrantInfo;
};
